import Vue from 'vue';
import VueI18n from 'vue-i18n';
import * as deepmerge from 'deepmerge';

import enPui from '@Pui9Translations/translations/en.json';

import enApp from './en.json';
import geApp from './ge.json';
const en = deepmerge.all([enPui, enApp]);
const ge = deepmerge.all([enPui, geApp]);

Vue.use(VueI18n);

export default new VueI18n({
	locale: 'en',
	fallbackLocale: 'en',
	silentFallbackWarn: true,
	messages: { en: en, ge: ge }
});
